import CustomerDeliveryAgreementView from 'shared/components/CustomerDeliveryLocationComponents/CustomerDeliveryAgreementView'
import DateRangePicker from 'shared/components/CustomerDeliveryLocationComponents/DateRangePicker'
import LocationTypeLink, {
  LocationType,
} from 'shared/components/CustomerDeliveryLocationComponents/LocationTypeLink'
import ShipToView from 'shared/components/CustomerDeliveryLocationComponents/ShipToView'
import React, { RefObject, useImperativeHandle } from 'react'
import { useState } from 'react'
import { Button, Col, Form, Modal, Row, Table } from 'react-bootstrap'
import { VestigingEnum } from 'shared/models/Enum'
import { ILocatieGlnModel } from 'shared/models/ILocatieGlnModel'
import { IModalObjectReference } from 'shared/models/References'
import CheckBoxList, {
  CheckBoxItem,
} from 'shared/components/CustomerDeliveryLocationComponents/CheckBoxList'
import { IOrderType } from 'shared/models/IOrderType'
import { selectLongDay, toLocalDate } from 'shared/service/helpers/DateUtilities'
import { CustomerModel } from 'shared/models/CutomerDeliveryLocations/CustomerModel'
import { DeliveryLocationModel } from 'shared/models/CutomerDeliveryLocations/DeliveryLocationModel'
import { CustomerDeliveryLocationsService } from 'services/CustomerDeliveryLocationsService'
import RouteToView from 'shared/components/CustomerDeliveryLocationComponents/RouteToView'

interface IProps {
  customer: CustomerModel
  warehouse: VestigingEnum
  orderTypes: IOrderType[]
  service: CustomerDeliveryLocationsService
  onSave?: () => void
  onHide?: () => void
  onLoading?: (isLoading: boolean) => void
}

const CustomerDeliveryLocation = React.forwardRef(
  (
    props: IProps,
    ref: RefObject<IModalObjectReference<DeliveryLocationModel>>
  ) => {
    const [extraSettingsVisible, setExtraSettingsVisible] =
      useState<boolean>(false)
    const [showModal, setShowModal] = useState<boolean>()
    const [currentDeliveryLocation, setCurrentDeliveryLocationLink] =
      useState<DeliveryLocationModel>()
    const [currentCustomer, setCurrentCustomer] = useState<CustomerModel>()
    const [routeToCustomer, setRouteToCustomer] = useState<CustomerModel>()
    const [orderTypes, setOrderTypes] = useState<IOrderType[]>()
    const [days, setDays] = useState<any[]>()
    const [glnLocation, setGlnLocation] = useState<ILocatieGlnModel>()
    const [glnRouteToLocation, setGlnRouteToLocation] =
      useState<ILocatieGlnModel>()
    const [startDate, setStartDate] = useState<Date>(new Date())
    const [endDate, setEndDate] = useState<Date>(new Date())
    const [currentLocationType, setCurrentLocationType] = useState<
      string | LocationType
    >()
    const [existingLink, setIsUpdate] = useState<boolean>()
    const [errorMessage, setErrorMessage] = useState<string>()
    const [isSaveAllowed, setIsSaveAllowed] = useState<boolean>(false)

    const getInitialDays = (): any[] => {
      return [
        { value: 1, name: selectLongDay(1) },
        { value: 2, name: selectLongDay(2) },
        { value: 3, name: selectLongDay(3) },
        { value: 4, name: selectLongDay(4) },
        { value: 5, name: selectLongDay(5) },
        { value: 6, name: selectLongDay(6) },
        { value: 0, name: selectLongDay(0) },
      ]
    }

    const showActiveSettings = () => {
      setExtraSettingsVisible(!extraSettingsVisible)
    }

    useImperativeHandle(ref, () => ({
      show: (link: DeliveryLocationModel) => {
        show(link)
      },
      hide: () => {
        hide()
      },
    }))

    const show = async (link: DeliveryLocationModel) => {
      console.log('show...')
      console.log(link)
      setErrorMessage(null)

      if (link.deliveryagreementlocationid !== 0) {
        //'Wijzigen'
        console.log('wijzigen...')
        setIsUpdate(true)
        setIsSaveAllowed(true)
        setStartDate(new Date(link.startdate))
        setEndDate(new Date(link.enddate))
        if (!!link.routetocustomerid) {
          await getRouteToCustomer(link.routetocustomerid)
        }
      } //Toevoegen
      else {
        console.log('toevoegen...')
        setIsUpdate(false)

        var currentDate = new Date(Date().toLocaleString())
        if (currentDate.getHours() >= 10) {
          if (currentDate.getDay() == 5) {
            //vrijdag dan 3 dagen vooruit
            currentDate.setDate(currentDate.getDate() + 3)
          } else {
            currentDate.setDate(currentDate.getDate() + 1)
          }
        }
        setStartDate(currentDate)
        setEndDate(currentDate)
        link.startdate = currentDate
        link.enddate = currentDate
      }
      setCurrentDeliveryLocationLink(link)
      setCurrentLocationType(link.deliveryagreementype)

      setOrderTypes(props.orderTypes)
      setCurrentCustomer(props.customer)
      setShowModal(true)
      setDays(getInitialDays())
    }

    const hide = () => {
      setErrorMessage(null)
      setExtraSettingsVisible(false)
      setShowModal(false)
      props.onHide()
    }

    const getRouteToCustomer = async (customerId: number) => {
      var resultPromise = await props.service.getCustomerById(customerId)
      var result
      if (resultPromise.success) {
        result = resultPromise.payLoad
      } else {
        setErrorMessage(
          'Het was niet mogelijk om de route-to klantgegevens op te halen: ' +
            resultPromise.errorMessage
        )
      }

      var routeTocustomerModel: CustomerModel = {
        customerId: result.klantId,
        customerName: result.klantNaam,
        customerEanCode: result.klantEanCode,
        customerNumber: result.klantNummer,
        warehouseId: 0,
        connectedAdresses: [],
      }
      setRouteToCustomer(routeTocustomerModel)
    }

    const updateLocationType = (locationType: LocationType | string) => {
      setCurrentLocationType(locationType)
    }

    const updateStartAndEndDate = (newStartDate: Date, newEndDate: Date) => {
      setStartDate(newStartDate)
      setEndDate(newEndDate)

      const tmpCustomerDeliveryAgreement = currentDeliveryLocation
      tmpCustomerDeliveryAgreement.startdate = newStartDate
      tmpCustomerDeliveryAgreement.enddate = newEndDate
      setIsSaveAllowed(true)
      setCurrentDeliveryLocationLink(tmpCustomerDeliveryAgreement)
    }

    const updateOrderTypes = (newOrderTypes: string) => {
      const tmpCustomerDeliveryAgreement = currentDeliveryLocation
      tmpCustomerDeliveryAgreement.ordertype = newOrderTypes
      setCurrentDeliveryLocationLink(tmpCustomerDeliveryAgreement)
    }

    const updateWeekDays = (newWeekDays: string) => {
      const tmpCustomerDeliveryAgreement = currentDeliveryLocation
      tmpCustomerDeliveryAgreement.days = newWeekDays
      setCurrentDeliveryLocationLink(tmpCustomerDeliveryAgreement)
    }

    const updateCombinatieCode = (newCombinatieCode: string) => {
      const tmpCustomerDeliveryAgreement = currentDeliveryLocation
      tmpCustomerDeliveryAgreement.combination = newCombinatieCode
      setCurrentDeliveryLocationLink(tmpCustomerDeliveryAgreement)
    }

    const setComment = (newComment: string) => {
      const tmpCustomerDeliveryAgreement = currentDeliveryLocation
      tmpCustomerDeliveryAgreement.comment = newComment
      setCurrentDeliveryLocationLink(tmpCustomerDeliveryAgreement)
    }

    const updateDeliveryAgreementShipToLink = (
      customer: CustomerModel,
      newLocation: ILocatieGlnModel
    ) => {
      if (customer.customerId !== props.customer.customerId) {
        throw new Error(
          'trying to update customerDeliveryAgreement for different customers ?'
        )
      }
      setIsSaveAllowed(true)
      setGlnLocation(newLocation)
      const tmpCustomerDeliveryAgreement = addShipToLocation(
        newLocation,
        customer
      )
      setCurrentCustomer(customer)
      setCurrentDeliveryLocationLink(tmpCustomerDeliveryAgreement)
    }

    const updateDeliveryAgreementRouteToLink = (
      customer: CustomerModel,
      newLocation: ILocatieGlnModel
    ) => {
      setIsSaveAllowed(true)
      setGlnRouteToLocation(newLocation)
      const tmpCustomerDeliveryAgreement = addRouteToLocation(
        newLocation,
        customer
      )
      setCurrentDeliveryLocationLink(tmpCustomerDeliveryAgreement)
    }

    const addShipToLocation = (
      newLocation: ILocatieGlnModel,
      customer: CustomerModel
    ) => {
      currentDeliveryLocation.shiptolocationgln =
        newLocation.locatieGlnCode.toString()
      currentDeliveryLocation.shiptolocationname = newLocation.locatieGlnNaam
      currentDeliveryLocation.shiptolocationid = newLocation.locatieGlnId

      return currentDeliveryLocation
    }

    const addRouteToLocation = (
      newLocation: ILocatieGlnModel,
      newCustomer: CustomerModel
    ) => {
      currentDeliveryLocation.routetolocationgln =
        newLocation?.locatieGlnCode?.toString() ?? null
      currentDeliveryLocation.routetolocationname =
        newLocation?.locatieGlnNaam ?? null
      currentDeliveryLocation.routetolocationglnid =
        newLocation?.locatieGlnId ?? null
      currentDeliveryLocation.routetocustomergln =
        newCustomer?.customerEanCode?.toString() ?? null
        currentDeliveryLocation.routetocustomerid =
            newCustomer?.customerId ?? null
      setRouteToCustomer(newCustomer)
      return currentDeliveryLocation
    }

    const save = () => {
      // actually do some saving here.
      console.log('saving...')
      console.log(currentDeliveryLocation)

      const newLink = getLink()
      console.log(newLink)
      if (!!props.onLoading) {
        props.onLoading(true)
      }
      props.service
        .saveLocationLink(newLink, props.customer)
        .then(result => {
          if (result.success) {
            console.log('result success')
            setErrorMessage(null)
            if (!!props.onSave) {
              props.onSave()
            }
            hide()
          } else {
            console.log('save fout')
            console.log(result)
            setErrorMessage(result.errorMessage)
          }
        })
        .finally(() => {
          if (!!props.onLoading) {
            props.onLoading(false)
          }
        })
    }

    const getLink = (): DeliveryLocationModel => {
      if (existingLink) {
        //workaround, dit zou eigenlijk altijd gevuld moeten zijn voor bestaande inregelingen maar komt nu (nog) niet mee
        console.log('getlink workaround')
        if (currentDeliveryLocation.ordertype == 'Alle') {
          console.log('Alle')
          var result = props.orderTypes
            .map(function (o) {
              return o.value
            })
            .join(',')
          console.log(result)
          currentDeliveryLocation.ordertype = result
        }
        if (currentDeliveryLocation.days == 'Alle') {
          currentDeliveryLocation.days = '1,2,3,4,5,6,0'
        }
        return currentDeliveryLocation
      } else {
        currentDeliveryLocation.deliveryagreementlocationid = 0
        currentDeliveryLocation.shiptolocationid = glnLocation.locatieGlnId
        currentDeliveryLocation.deliveryagreementype = currentLocationType

        console.log('to ADD deliverylocation is: ')
        console.log(currentDeliveryLocation)
        return currentDeliveryLocation //rest komt als het goed is uit de AAR
      }
    }

    return (
      <>
        {currentDeliveryLocation !== null && (
          <Modal show={showModal} onHide={hide} size={'xl'}>
            <Modal.Header closeButton>
              <Modal.Title>{'Onderhouden Afleverlocatie Klant'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Table>
                <tbody>
                  <CustomerDeliveryAgreementView
                    customerDeliveryAgreement={currentDeliveryLocation}
                  />
                  <tr style={{ height: '5px' }}></tr>
                  <LocationTypeLink
                    locationType={currentLocationType}
                    onLocationTypeChanged={updateLocationType}
                  />
                  <tr style={{ height: '5px' }}></tr>
                  <ShipToView
                    customer={currentCustomer}
                    location={glnLocation}
                    warehouse={props.warehouse}
                    existingLocation={currentDeliveryLocation}
                    onShipToAddressChanged={updateDeliveryAgreementShipToLink}
                  />
                  <tr style={{ height: '5px' }}></tr>
                  <RouteToView
                    customer={routeToCustomer ?? currentCustomer}
                    location={glnRouteToLocation ?? glnLocation}
                    warehouse={glnRouteToLocation?.vestigingCode ?? props.warehouse}
                    existingLocation={currentDeliveryLocation}
                    onRouteToAddressChanged={updateDeliveryAgreementRouteToLink}
                    isShipToLocationSet={!currentDeliveryLocation?.shiptolocationgln}
                  />
                  <tr style={{ height: '5px' }}></tr>
                  <DateRangePicker
                    startDate={startDate ?? new Date()}
                    endDate={endDate ?? new Date()}
                    maxEndDate={currentDeliveryLocation?.deliveryagreementenddate ? toLocalDate(currentDeliveryLocation.deliveryagreementenddate) : undefined}
                    endDateShouldBeAfterStartDate={true}
                    onDateChanged={updateStartAndEndDate}
                  />
                  <tr style={{ height: '5px' }}></tr>
                  <tr className='border'>
                    <td>
                      <h5>Code Combinatie</h5>
                    </td>
                    <td colSpan={2}>
                      <input
                        type='text'
                        defaultValue={currentDeliveryLocation?.combination}
                        onChange={e => updateCombinatieCode(e.target.value)}
                      />
                    </td>
                  </tr>
                  {(currentLocationType === LocationType.Dag ||
                    currentLocationType === 'Dag') && (
                    <tr style={{ height: '5px' }}>
                      <td colSpan={3} className='text-center'>
                        <Button variant='primary' onClick={showActiveSettings}>
                          Extra instellingen {!extraSettingsVisible && 'uit'}
                          {extraSettingsVisible && 'in'}klappen
                        </Button>
                      </td>
                    </tr>
                  )}
                  {extraSettingsVisible && <tr style={{ height: '5px' }}></tr>}
                  {extraSettingsVisible && (
                    <CheckBoxList
                      title='OrderTypes'
                      type='switch'
                      showValue={true}
                      selectedData={currentDeliveryLocation.ordertype}
                      checkBoxItems={orderTypes.map(
                        ot => new CheckBoxItem(ot.name, ot.value)
                      )}
                      onSelectionChanged={e =>
                        updateOrderTypes(e.map(cbi => cbi.getValue()).join())
                      }
                    />
                  )}
                  {extraSettingsVisible && <tr style={{ height: '5px' }}></tr>}
                  {extraSettingsVisible && (
                    <CheckBoxList
                      title='Dagen'
                      type='switch'
                      showValue={false}
                      selectedData={currentDeliveryLocation.days}
                      checkBoxItems={days.map(
                        day => new CheckBoxItem(day.name, day.value)
                      )}
                      onSelectionChanged={e =>
                        updateWeekDays(e.map(cbi => cbi.getValue()).join())
                      }
                    />
                  )}
                  {extraSettingsVisible && <tr style={{ height: '5px' }}></tr>}
                  {extraSettingsVisible && (
                    <tr className='border'>
                      <td>
                        <h5>Toelichting</h5>
                      </td>
                      <td colSpan={2}>
                        <Form>
                          <Form.Group as={Row} className='mb-3'>
                            <Col sm={12}>
                              <Form.Control
                                as='textarea'
                                rows={4}
                                defaultValue={currentDeliveryLocation?.comment}
                                onChange={e => setComment(e.target.value)}
                              />
                            </Col>
                          </Form.Group>
                        </Form>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              <div>
                {!!errorMessage && (
                  <div className='alert alert-danger maxedbox'>
                    {errorMessage}
                  </div>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant='primary'
                onClick={save}
                disabled={!isSaveAllowed}
              >
                Opslaan
              </Button>
              <Button variant='secondary' onClick={hide}>
                Sluiten
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    )
  }
)

export default CustomerDeliveryLocation
